import { NotePage } from '../NotePage/NotePage';
import { NeuralTherapyParagraphs } from './Paragraphs';

export const NeuralTherapy = () => (
  <NotePage
    title="Pain, mobility, and daily comfort"
    eyebrow="Wellness note"
    summary="A wellness note about pain patterns, nervous-system sensitivity, movement, and the value of a personalized medical conversation."
    paragraphs={NeuralTherapyParagraphs}
    relatedTitle="Pain Control Management"
    appointmentServiceValue="Neural Therapy"
  />
);
